export const loadCypress = () => {
  const windowVars = window as any;
  try {
    if (windowVars.Cypress) {
      //allow use of react dev tools within the cypress interface
      windowVars.__REACT_DEVTOOLS_GLOBAL_HOOK__ = windowVars.parent.__REACT_DEVTOOLS_GLOBAL_HOOK__;
    }
  } catch (e) {}
};
